import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
$(".head li").eq(2).addClass("active")
$(window).scroll(function () {
    // 可是窗口滚动条发生滚动的时候 垂直方向滚动到多少距离的时候 让头部导航条设置上一个固定定位的样式
    if ($(window).scrollTop()>=($("header").height())) {
        $(".details-nav").addClass("fixed")
    } else {
        $(".details-nav").removeClass("fixed")
    }
})
var swiper1 = new Swiper(".lunbo .swiper", {
    breakpoints: {
        320: { //当屏幕宽度大于等于320
        slidesPerView: 1,
        },
        768: { //当屏幕宽度大于等于768 
            slidesPerView: 2,
            spaceBetween: 16,
        },
        1280: { //当屏幕宽度大于等于1280
            slidesPerView: 2,
            spaceBetween: 16,
        }
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    centeredSlides: true,
    loop:true,
    initialSlide: 0,
    observer: true,
    observeParents: true,
});
$(".lunbo").on("mouseover",'.swiper-slide-active',function() {
    $(".lunbo .swiper-slide .pro_up").stop(1000).slideUp();
    $(this).find(".pro_up").stop(1000).slideDown();
})
$(".lunbo").on("mouseout",'.swiper-slide-active',function() {
    $(".lunbo .swiper-slide .pro_up").stop(1000).slideUp();
    $(this).find(".pro_up").stop(1000).slideUp();
})